function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  height: 0.375rem;\n  background: ", ";\n\n  ", " {\n    height: 0.25rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { from } from "../../theme";
export var Strip = styled.div(_templateObject(), function (props) {
  return "linear-gradient(\n     to right,\n     ".concat(props.theme.variables.appLayout.stripColors.stripColor1, " 0,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor1, " 28.27%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor2, " 28.27%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor2, " 32.40%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor3, " 32.40%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor3, " 60.74%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor4, " 60.74%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor4, " 83.54%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor5, " 83.54%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor5, " 91.51%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor6, " 91.51%,\n     ").concat(props.theme.variables.appLayout.stripColors.stripColor6, " 100%\n   )");
}, from('lg'));